/**
 * A global namespace for `DOMMouseScroll` event.
 */
const DOMMouseScrollEvent = 'DOMMouseScroll';
export default DOMMouseScrollEvent;
